import { ReducerFunctions } from '../../utils';
import { GetPageDetails, GetSummary, ImportApi } from './imports';

export const get_page_details_reducer = ReducerFunctions(GetPageDetails, {});
export const get_summary_reducer = ReducerFunctions(GetSummary, {})
export const import_api_reducer = ReducerFunctions(ImportApi, {})
